import {injectScript} from '@convincely/core/src/bootstrap.js';

export async function injectScriptAndReady(path) {
  return new Promise((resolve) => {
    injectScript(path).addEventListener('load', resolve, {once: true});
  });
}
